<template>
  <v-container>
    <v-row>
      <v-col cols="12">   

        <v-btn absolute dark bottom fab right 
               color="success" 
               to="/orders/new/room1" 
               v-if="!getLoadingStatus" >
          <v-icon>mdi-plus</v-icon>
        </v-btn>

        <div class="text-center" v-if="getLoadingStatus">
          <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
        </div>

        <v-simple-table v-else>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Комната</th>
                <th class="text-left">Время</th>
                <th class="text-left">Заказ</th>
                <th class="text-left" v-if="userIsAuthenticated">Статус</th>
                <th class="text-left" v-if="userIsAuthenticated">Удалить</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="order in orders" :key="order.id" v-bind:class="{ task: order.status }">
                <td>{{ order.room }}</td>
                <td>{{ order.timestamp | timestampToDateTime }}</td>
                <td>Чай: {{ order.tea }} | Кофе: {{ order.coffee }} | Вода: {{ order.water }}</td>
                <td @click="updateOrder(order.id)" v-if="userIsAuthenticated">
                  <v-btn icon color="white" v-if="order.status">
                    <v-icon>mdi-checkbox-blank-outline</v-icon>
                  </v-btn>
                  <v-btn icon v-else>
                    <v-icon>mdi-checkbox-marked-outline</v-icon>
                  </v-btn>
                </td>
                <td v-if="userIsAuthenticated">
                  <v-btn icon color="red lighten-3" @click="deleteOrder(order.id)">
                    <v-icon>mdi-close-circle-outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        

      </v-col>
    </v-row> 
  </v-container>
</template>

<script>

  export default {
    data: () => ({

    }),
    watch: {
      orders: function (a, b) {
        if(a.length > b.length){
          console.log('новый заказ!');
          let aud = new Audio();
          aud.src = 'https://firebasestorage.googleapis.com/v0/b/conf-bakinity1.appspot.com/o/static%2Fnew_order.mp3?alt=media&token=40b9baba-6c11-4062-8930-fe991e709bda';
          aud.play();
        }
      }
    },
    methods:{
      deleteOrder(id){
        this.$store.dispatch('deleteOrder', id);
      },
      updateOrder(id){
        this.$store.dispatch('updateOrder', id);
      }
    },
    computed: {
      orders(){
        return this.$store.getters.loadedOrders;
      },
      getLoadingStatus(){
        return this.$store.state.loading;
      },
      userIsAuthenticated(){
        this.$store.dispatch('userIsAuthenticated');
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
      }
    },
    created(){
      this.$store.dispatch('loadOrders');
    }
  }

</script>

<style scoped>
  table tbody tr.task {
    font-weight: bold;
    color: #FFF;
    background: #F44336;
  }
  table tbody tr.task:hover {
    background: #E53935 !important;
  }

</style>